import { isEmrIntegrationToolBarVisible } from '../../helpers/emrIntegration'

import {
  LIST_PANEL_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR,
  NOTE_EDITOR_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR
} from '../constants'

const getListPanelMarginProps = () => {
  if (isEmrIntegrationToolBarVisible()) {
    return {
      marginTop: LIST_PANEL_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR
    }
  }
  return {}
}

const getNoteEditorMarginProps = () => {
  if (isEmrIntegrationToolBarVisible()) {
    return {
      marginTop: NOTE_EDITOR_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR
    }
  }
  return {}
}

export { getListPanelMarginProps, getNoteEditorMarginProps }
